import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpCommunity'

// GET all user-published content for moderation (feed + list)
export const getModerationFeed = (params = { per_page: 15, page: 1 }) =>
	Http.get(`/moderation/feed${serialize(params)}`)

// GET all stories for moderation (not synced into the feed, ephemeral content)
export const getModerationStories = (params = { per_page: 15, page: 1 }) =>
	Http.get(`/moderation/stories${serialize(params)}`)

// GET moderation stats
export const getModerationStats = params => Http.get(`/moderation/stats${serialize(params)}`)

/**
 * Remoção com motivo + notificação WebSocket + Firebase push + registro de strike.
 * O backend lida com tudo internamente em uma única chamada.
 *
 * @param {Object} params
 * @param {string} params.content_type  - 'pulse' | 'post' | 'video' | 'comment' | 'review' | 'quiz'
 * @param {number} params.content_id    - ID do conteúdo
 * @param {string} params.reason        - Motivo da remoção (obrigatório)
 * @param {boolean} params.notify_user  - Enviar notificação in-app (WebSocket) ao usuário
 * @param {boolean} params.notify_push  - Enviar push notification via Firebase ao usuário
 * @param {boolean} params.block_publishing - Bloquear o usuário de publicar novos conteúdos
 */
export const takedownContent = (params = {}) =>
	Http.post(`/moderation/content/${params.content_type}/${params.content_id}/takedown`, {
		reason: params.reason,
		notify_user: params.notify_user ?? true,
		notify_push: params.notify_push ?? true,
		block_publishing: params.block_publishing ?? false,
	})

// RESTORE previously removed content
export const restoreContent = (params = { content_type: null, content_id: null }) =>
	Http.post(`/moderation/content/${params.content_type}/${params.content_id}/restore`)

// GET strikes e histórico de moderação de um usuário
export const getUserModerationHistory = (userUuid, params = {}) =>
	Http.get(`/moderation/users/${userUuid}/history${serialize(params)}`)

// BLOCK user from publishing
export const blockUserPublishing = (userUuid, params = {}) =>
	Http.post(`/moderation/users/${userUuid}/block-publishing`, params)

// UNBLOCK user publishing
export const unblockUserPublishing = (userUuid) =>
	Http.post(`/moderation/users/${userUuid}/unblock-publishing`)

// GET list of users blocked from publishing
export const getBlockedUsers = (params = {}) =>
	Http.get(`/moderation/blocked-users${serialize(params)}`)
